import Reflux from 'reflux';
import ShowData from 'shared/data/Show';
import ScheduleData from 'shared/data/Schedule';
import ListData from 'shared/data/List';
import { DisplayTypes } from 'shared/constants/FlowConstants';

let async = { asyncResult: true },
  ShowActions = Reflux.createActions({
    save: async,
    saveField: async,
    toggleActualDurations: {},
  });

ShowActions.save.listenAndPromise(
  (teamId, eventId, showId, changes, displayType) => {
    var handler = ShowData.update;

    if (displayType === DisplayTypes.schedule) handler = ScheduleData.update;
    if (displayType === DisplayTypes.list) handler = ListData.update;

    return handler(teamId, eventId, showId, changes);
  },
);

ShowActions.saveField.listenAndPromise(
  (teamId, eventId, showId, field, value, displayType) => {
    var handler = ShowData.updateField;

    if (displayType === DisplayTypes.schedule)
      handler = ScheduleData.updateField;
    if (displayType === DisplayTypes.list) handler = ListData.updateField;

    return handler(teamId, eventId, showId, field, value);
  },
);

export default ShowActions;
